import {Button as Mbutton, Dialog, DialogActions, DialogContent, Typography} from "@material-ui/core";
import {useState} from "react";
import {
    Button,
    DateInput,
    FormDataConsumer,
    FormWithRedirect,
    SelectInput,
    useNotify,
    useRecordContext,
    useRefresh
} from "react-admin";
import {client} from "../../dataProvider";
import {FormSaveButton} from "../../components/FormSaveButton";
import IconCancel from "@material-ui/icons/Cancel";
import {useToggler} from "../../shared/hooks/useToggler";
import {AutocompleteInput, ReferenceInput} from "ra-ui-materialui";
import { FaRegEdit } from "react-icons/fa";
import {ReferenceInputBank} from "../../components/reference-inputs/ReferenceInputBank";
import {initInput} from "../../shared/utils";
export const ChangeStatusReceiptButton = ({edit = false}:{edit:boolean}) => {
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const record = useRecordContext()
    const [loading, setLoading] = useState<boolean>(false);
    const handleSubmit = (values: any) => {
        setLoading(true);
        values.id = record.id;
        client("bank_receipt/change_status", {
            method: "POST",
            data: values,
        })
            .then(() => {
                notify("Fatto!", "success");
                refresh();
            })
            .catch((response) =>
                notify(
                    response.response.data.error,
                    "error"
                )
            )
            .finally(() => setLoading(false));
    };
    let receipt_status_choices = [
        {
            display_name: record.payment_schedule.invoice.invoice_type === "S" ? "Incassata" : "Pagata",
            value: "CA",
        },
        {
            display_name: "Insoluta",
            value: "US",
        },
        {
            display_name: "Insoluta e pagata con altro metodo di pagamento",
            value: "PA",
        },
    ]
    if(record.receipt_status === "CA") receipt_status_choices.push({
        display_name: "Stornata",
        value: "RE",
    })
    return (
        <>
            <Mbutton
                variant="contained"
                onClick={() => {
                    setOpen(true);
                }}
            >
                {edit ? <FaRegEdit size={20}/> :  "Cambia stato"}
            </Mbutton>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm" fullWidth
            >
                <FormWithRedirect
                    save={handleSubmit}
                    render={({handleSubmitWithRedirect, pristine, saving, form}) => (
                        <>
                            <DialogContent>
                                <SelectInput
                                    fullWidth
                                    label="Stato"
                                    source="receipt_status"
                                    optionText={"display_name"}
                                    optionValue="value"
                                    required
                                    choices={receipt_status_choices}
                                />
                                <ReferenceInputBank source="bank" label="Banca" defaultValue={1} />
                                <FormDataConsumer>
                                    {({formData}) => (
                                        formData.receipt_status === "US" ? (
                                            <>
                                                <Typography variant="h6">Puoi inserire una data per creare una nuova
                                                    riba relativa alla fattura</Typography>
                                                <DateInput
                                                    fullWidth
                                                    source="new_expiration_date"
                                                    label="Scadenza"
                                                ></DateInput>
                                            </>
                                        ) : formData.receipt_status === "PA" || formData.receipt_status === "RE" ? (
                                            <>
                                                <Typography variant="h6">Incassa con un'altro metodo di
                                                    pagamento</Typography>
                                                <ReferenceInput
                                                    reference="payment-terms"
                                                    source="payment-terms"
                                                    perPage={10000}
                                                    fullWidth
                                                    label="Termini di pagamento"
                                                >
                                                    <AutocompleteInput optionText="label"/>
                                                </ReferenceInput>
                                            </>
                                        ) : null
                                    )}
                                </FormDataConsumer>

                            </DialogContent>
                            <DialogActions>
                                <Button label="ra.action.cancel" onClick={() => setOpen(false)}>
                                    <IconCancel/>
                                </Button>
                                <FormSaveButton
                                    handleSubmit={() => handleSubmitWithRedirect!()}
                                    submitting={loading}
                                    pristine={pristine}
                                    label="Crea"
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    )
};

